import { Button } from 'components/ui';
import { useSignOutAction } from 'pages/Auth/hooks';

const SignOutButton = () => {
  const signOut = useSignOutAction();

  return (
    <Button onClick={signOut} sizeVariant="compact" type="button" variant="contained" visualVariant="positive">
      Sign out
    </Button>
  );
};

export default SignOutButton;
